import { Action } from 'redux';

import { SET_ADULTS, SET_CHILDREN, SET_INFANTS, SET_CLASS } from '../../actions/Flight/passengers';

export interface PassengerState {
    adults: number;
    children: number;
    infants: number;
    serviceClass: 'Y' | 'C';
}

const initialState: PassengerState = {
    adults: 1,
    children: 0,
    infants: 0,
    serviceClass: 'Y'
};

export function passengers(state: PassengerState = initialState, action: Action) {
    switch (action.type) {
        case SET_ADULTS: {
            const adults = (action as any).count;
            return {
                ...state,
                adults
            };
        }
        case SET_CHILDREN: {
            const children = (action as any).count;
            return {
                ...state,
                children
            };
        }
        case SET_INFANTS: {
            const infants = (action as any).count;
            return {
                ...state,
                infants
            };
        }
        case SET_CLASS: {
            const serviceClass = (action as any).sc;
            return {
                ...state,
                serviceClass
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Flight/passengers.ts